export const BUY_BUTTON_SHOW = 'BUY_BUTTON_SHOW';
export const BUY_BUTTON_HIDE = 'BUY_BUTTON_HIDE';
export const BUY_BUTTON_ENABLE = 'BUY_BUTTON_ENABLE';
export const BUY_BUTTON_DISABLE = 'BUY_BUTTON_DISABLE';

export const enable = () => ({
    type: BUY_BUTTON_ENABLE,
    payload: {
        disabled: false
    }
})

export const disable = () => ({
    type: BUY_BUTTON_DISABLE,
    payload: {
        disabled: true
    }
})

export const show = () => ({
    type: BUY_BUTTON_SHOW,
    payload: {
        hidden: false
    }
})

export const hide = () => ({
    type: BUY_BUTTON_HIDE,
    payload: {
        hidden: true
    }
})